import { ISupplierDetailVenue } from '@bridebook/models/source/models/Suppliers.types';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { isStringNonEmpty } from '@bridebook/toolbox/src/is';

const getVenueTypeTranslation = (): Record<keyof ISupplierDetailVenue['type'], string> => {
  const i18n = getI18n();
  return {
    barn: i18n.t('filters:barn'),
    castle: i18n.t('filters:castle'),
    cityHotelCityVenue: i18n.t('supplier:venueType.cityHotel'),
    conferenceCentre: i18n.t('supplier:venueType.conferenceCentre'),
    countryHouseManorHouse: i18n.t('supplier:venueType.countryHouse'),
    cruiseBoatYacht: i18n.t('supplier:venueType.cruise'),
    gardenOutdoor: i18n.t('supplier:venueType.garden'),
    golfCourse: i18n.t('filters:golfCourse'),
    hotel: i18n.t('filters:hotel'),
    museumAttraction: i18n.t('supplier:venueType.museum'),
    placeOfWorship: i18n.t('supplier:venueType.worship'),
    pubRestaurant: i18n.t('supplier:venueType.pub'),
    resort: i18n.t('supplier:venueType.resort'),
    sportingVenueStadium: i18n.t('supplier:venueType.sporting'),
    statelyHome: i18n.t('supplier:msg.stately'),
    townHallRegistryOffice: i18n.t('supplier:venueType.townHall'),
    uniqueVenueType: i18n.t('supplier:venueType.uniqueVenueType'),
    unselected: null,
    warehouseFactory: i18n.t('supplier:venueType.warehouse'),
  };
};

export const getVenueTypeTranslated = (venue: ISupplierDetailVenue): string | null => {
  try {
    const venueType = venue?.type?.[0];
    let value: string | null = null;
    if (venueType === 'otherVenueType') {
      value = venue.typeOther || null;
    } else if (venueType && isStringNonEmpty(venueType)) {
      value = getVenueTypeTranslation()[venueType as keyof ISupplierDetailVenue['type']];
    } else {
      value = null;
    }

    return isStringNonEmpty(value) ? value : null;
  } catch (e) {
    return null;
  }
};
